<template lang="pug">
  form(@submit.prevent="navigate('sistema.docModelos.edit.parametros')")
    p.text-large - Informações do Modelo
    .columns
      .column.col-6.col-md-8.col-sm-12
        .columns
          .column.col-12
            form-group(:label="'doc_modelo.titulo' | tModel" :validation="$v.resource.titulo")
              input.form-input(v-model="$v.resource.titulo.$model")
          .column.col-12
            form-group(:label="'doc_modelo.descricao' | tModel" :validation="$v.resource.descricao")
              input.form-input(v-model="$v.resource.descricao.$model")
          .column.col-12
            .form-group
              label.form-switch
                input(type="checkbox" v-model="$v.resource.ativo.$model")
                i.form-icon
                | {{ 'doc_modelo.ativo' | tModel }}
        .pt-2
          .divider
          btn-logs(entityName='DocModelo', :entityId='resource.id' v-acl:allowed.admin.logs.index)
          button.btn.btn-primary(:disabled="$v.resource.$invalid")
            btn-content(name="next")
</template>

<script>
import editMixin from './mixin'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [editMixin],

  validations: {
    resource: {
      titulo: { required },
      descricao: { required },
      ativo: { required },
    },
  },
}
</script>
